import { Input as ChakraInput } from '@chakra-ui/react';
import styled from 'styled-components';

type InputStyleType = {
  isLabelAboveField?: boolean;
};

export const InputBox = styled.div<InputStyleType>`
  display: ${(props) => (props.isLabelAboveField ? 'block' : 'flex')};
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  gap: ${({ isLabelAboveField = false }) => (isLabelAboveField ? 0 : 12)}px;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const InputLabel = styled.label<InputStyleType>`
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  font-size: 14px;
  flex: 1;
  display: block;
  line-height: 21px;
  min-height: 21px;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div<InputStyleType>`
  flex-shrink: 0;
  position: relative;
  width: ${({ isLabelAboveField = false }) => (isLabelAboveField ? '100%' : '50%')};

  input {
    background-color: ${(props) => props.theme.colors['neutral-0']};
  }

  & > svg {
    fill: ${({ theme }) => theme.colors['neutral-70']};
    position: absolute;
    left: 12px;
    top: 10px;
    width: 14px;
    height: 14px;
    z-index: 2;
    display: block;
  }

  input#githubUrl,
  input#linkedinUrl,
  input#trioProfileUrl {
    color: ${(props) => props.theme.colors['primary-60']};
  }
`;

export const Input = styled(ChakraInput)`
  min-height: 48px;
  border-radius: 8px !important;
  border-color: transparent !important;
  background-color: ${({ theme }) => theme.colors['neutral-20']} !important;
  transition: border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1), background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:focus, &:focus-visible {
    border-color: ${({ theme }) => theme.colors['primary-60']} !important;
    border-width: 2px !important;
    background-color: ${({ theme }) => theme.colors['neutral-0']} !important;
    box-shadow: none !important;
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors['neutral-60']};
  }
`;
